import { tr } from 'mmfintech-commons'
import { useCryptoCurrencyNotes } from 'mmfintech-checkout-commons'

import { InfoIcon } from '@icons'
import { WarningMessageTitle, WarningMessageWrapper } from './WarningMessage.styled'

import type { CryptoNotesDetails } from 'mmfintech-checkout-commons/types'

export const WarningMessage = ({ currency }) => {
  const notes = useCryptoCurrencyNotes(currency, true)

  if (notes) {
    return (
      <WarningMessageWrapper>
        <WarningMessageTitle>
          <InfoIcon />
          {tr('FRONTEND.DEPOSIT.CRYPTO_DETAILS.PLEASE_NOTE', 'Please note')}
        </WarningMessageTitle>

        {notes.map((line: CryptoNotesDetails) => (
          <p key={line.keyName}>{tr(line.keyName, line.defaultValue)}</p>
        ))}
      </WarningMessageWrapper>
    )
  }

  return null
}
